import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import SearchIcon from 'material-ui-icons/Search';
import Paper from 'material-ui/Paper';
import PrcInput from './Input.js';

class AutoCompleteInput extends React.Component {
    static propTypes = {
        inputValue: PropTypes.string.isRequired,
        handleInputChange: PropTypes.func.isRequired,
        inputPlaceHolder: PropTypes.string,
        suggestions: PropTypes.array,
        getSuggestionValue: PropTypes.func.isRequired,
        renderSuggestion: PropTypes.func.isRequired,
    };

    state = {
        suggestions: this.props.suggestions,
        suggestion: ''
    };

    renderInput = (inputProps) => {
        const {classes, ref, ...other} = inputProps;
        return (
            <PrcInput
                className="readings__form--control"
                adornment={<SearchIcon className="search__input--icon"/>}
                id="Readings_PRC_Search"
                label="PRC book search"
                InputProps={{
                    disableUnderline: true,
                    inputRef: ref,
                    value: this.props.inputValue,
                    onChange: this.handleChange,
                    ...other,
                }}
            />
        );
    }

    renderSuggestionsContainer = (options) => {
        const {containerProps, children} = options;
        return (
            <Paper {...containerProps} className="autoComplete__suggestions--containter" square>
                {children}
            </Paper>
        );
    }

    handleSuggestionsFetchRequested = ({value}) => {
        this.props.getSuggestions(value);
    }

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    }

    handleChange = (e, {newValue}) => {
        this.props.handleInputChange(newValue)
    }

    render () {
        return (
            <div className="form__autoComplete">
                <Autosuggest
                    renderInputComponent={this.renderInput}
                    suggestions={this.props.suggestions}
                    onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                    renderSuggestionsContainer={this.renderSuggestionsContainer}
                    getSuggestionValue={this.props.getSuggestionValue}
                    renderSuggestion={this.props.renderSuggestion}
                    inputProps={{
                        value: this.props.inputValue,
                        onChange: this.handleChange,
                        placeholder: this.props.inputPlaceHolder,
                    }}
                />
            </div>
        );
    }
}

export default AutoCompleteInput;
